module.exports = __webpack_public_path__ + "static/media/zevon_logo.8c62f65d.png";